<template>
  <div v-if="studentResourceData">
    <!-- <h1 class="auth-page-heading">Take Assessment</h1> -->
    <v-expansion-panels accordion multiple flat v-model="panel">
      <!-- <v-expansion-panel>
        <v-expansion-panel-header class="pa-0">
          <span class="expansion-tab-heading">
            Why should you take this assessment?
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="pa-0 assessment">
          {{ studentResourceData.resource_details.description }}
        </v-expansion-panel-content>
      </v-expansion-panel> -->

      <v-expansion-panel>
        <v-expansion-panel-header class="pa-0">
          <span class="expansion-tab-heading"> How it works? </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="pa-0 assessment">
          {{ studentResourceData.resource_details.instruction }}
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-divider class="my-4" />

    <v-expansion-panels accordion multiple flat v-model="panel1">
      <v-expansion-panel>
        <v-expansion-panel-header class="pa-0">
          <span class="expansion-tab-heading">
            Assessment
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="pa-0 assessment">
          Please use <b>{{ authToken.decodedToken().email }}</b> in the form
          below.
          <iframe
            class="frame mt-4"
            :src="studentResourceData.resource_details.source"
            frameborder="0"
            marginheight="0"
            marginwidth="0"
          >
            Loading…
          </iframe>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- <v-divider class="my-4" v-if="studentResourceData.status == 'Open'" />
    <v-row
      class="ma-0 mt-4"
      justify="center"
      align="center"
      v-if="studentResourceData.status == 'Open'"
    >
      <v-btn
        class="btn-mark-done"
        text
        @click="markCompleted"
        :loading="updatingStatus"
      >
        <span> Send me the report </span>
        <v-icon right>mdi-send</v-icon>
      </v-btn>
    </v-row>
    <v-divider class="my-4" v-if="studentResourceData.status == 'Open'" /> -->

    <v-divider class="my-4" v-if="studentResourceData.status != 'Open'" />

    <!-- <v-row class="ma-0">
    
      <v-col cols="2" class="lables ps-0">Tags</v-col>
      <v-col>
        <v-chip
          small
          class="me-2 tags"
          v-for="(tag, i) in studentResourceData.resource_details.tags"
          :key="i"
        >
          {{ tag.name }}
        </v-chip>
      </v-col>
    </v-row> -->

    <StudentResourceComments
      class="report-section"
      v-if="studentResourceData.id > 0"
      :showResultButton="studentResourceData.status == 'Open'"
      :comments="null"
      :id="studentResourceData.id"
      :getUrl="apiUrl.studentResourceCommentList"
      :addUrl="apiUrl.studentResourceCommentAdd"
      :editUrl="apiUrl.studentResourceCommentEdit"
      :deleteUrl="apiUrl.studentResourceCommentDelete"
      :type="'Student Resource'"
      title="Report"
    />

    <ResourceRating :id="studentResourceData.resource_details.resource" />

    <v-divider class="my-4" />

    <v-row class="ma-0">
      <!-- <v-icon>mdi-tag</v-icon> -->
      <v-col cols="12" class="lables ps-0">Rating</v-col>
      <v-col cols="12" class="ps-0">
        <v-row align="center" class="ma-0">
          <v-rating
            :value="studentResourceData.resource_details.average_rating"
            color="amber"
            dense
            half-increments
            readonly
            size="24"
            background-color="amber lighten-3"
            class="me-1 ms-n1"
          ></v-rating>
          <span class="me-2 rating-text">
            {{ studentResourceData.resource_details.average_rating }} Stars
            <!-- /
            {{ studentResourceData.resource_details.ratings_count }} reviews -->
          </span>

          <v-btn
            small
            color="#506cff2e"
            @click="$store.state.parentDashboard.showRatingSheet = true"
            elevation="0"
          >
            <span style="font-size: 14px; color:#506CFF"
              >Rate this resource</span
            >
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
    <v-divider class="my-4" />

    <v-dialog
      v-model="successDialog"
      max-width="290"
    >
      <v-card>
        <v-card-text>Thanks for submitting the assessment. You will be notified when the report is available.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="successDialog = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import StudentResourceComments from "../../components/Comments";
  import { API_CLIENT_URL } from "../../../../constants/urls";
  // import { ROUTER_URL } from "../../../../constants/parents/urls";
  import store from "../../../../store";
  import Keys from "../../../../constants/keys";
  import AmplitudeHelper from "../../../../amplitude";
  import Axios from "../../../../api/BaseAxios";
  import ResourceRating from "../../components/ResourceRating";
  import authToken from "../../../../common/authToken";

  export default {
    name: "TakeAssessment",
    components: {
      StudentResourceComments,
      ResourceRating,
    },
    data() {
      return {
        apiUrl: API_CLIENT_URL,
        updatingStatus: false,
        panel: [0, 1],
        rateResource: false,
        panel1: [],
        successDialog: false,
        authToken: authToken,
      };
    },
    created() {
      if (
        this.$store.state.parentAuth.studentResourceData &&
        (this.$store.state.parentAuth.studentResourceData.status == "Open" ||
          this.$store.state.parentAuth.studentResourceData.id < 0)
      ) {
        this.panel1 = [0];
      } else {
        this.panel = [];
      }
    },
    computed: {
      stepCount: {
        get() {
          return this.$store.state.parentAuth.stepCount;
        },
        set(value) {
          store.dispatch("parentAuth/updateStepCount", value);
        },
      },
      studentResourceData: {
        get() {
          return this.$store.state.parentAuth.studentResourceData;
        },
        set(value) {
          store.dispatch("parentAuth/updateStudentResource", value);
        },
      },
    },
    watch: {},
    methods: {
      markCompleted() {
        const self = this;

        this.updatingStatus = true;

        const successHandler = (res) => {
          AmplitudeHelper.registerEvent(
            "Student Resource - Mark as Closed",
            this.resourceDetails
          );

          console.log(res);
          self.updatingStatus = false;

          self.studentResourceData.status = "Closed";
          // self.$router.push({
          //   name: ROUTER_URL.dashboard.children.home.name,
          // });
        };

        const failureHandler = (res) => {
          console.log(res);
          self.updatingStatus = false;
        };

        let requestParams = {};
        requestParams[Keys.RESOURCE_ID] = this.studentResourceData.id;

        requestParams[Keys.STATUS] = 0;

        Axios.request_PATCH(
          API_CLIENT_URL.studentResourceUpdateStatus,
          requestParams,
          {},
          successHandler,
          failureHandler,
          false
        );
      },
    },
    mounted() {},
  };
</script>

<style scoped>
  .frame {
    width: 100%;
    height: 50vh;
    border: 0;
    transform: scale(1);
    transform-origin: 0 0;
  }
  .btn-mark-done {
    min-height: 44px;
    border-radius: 8px;
    width: 100%;
    border: 2px solid #5271ff;
    color: #5271ff;
  }

  .btn-mark-done > span > span {
    font-weight: medium;
    font-size: 1.125rem;
    line-height: 1.215rem;
    color: #5271ff;
  }

  .expansion-tab-heading {
    font-weight: bold;
    font-size: 1.125rem;
    line-height: 1.215rem;
    letter-spacing: 0px;
    color: #5468ff;
  }

  .tags {
    background: #5271ff1a 0% 0% no-repeat padding-box !important;
    border: 0.800000011920929px solid #5271ff;
    border-radius: 242px;
  }

  .rating-text {
    font-weight: bold;
    font-size: 0.8rem;
    line-height: 1.25rem;
    color: #ff7f2d;
  }

  .lables {
    font-weight: 600;
    font-size: 1.12rem;
    line-height: 1.25rem;
    color: #5468ff;
  }
</style>

<style>
  .assessment > .v-expansion-panel-content__wrap {
    padding: 0 0px 16px !important;
  }
</style>
